export const state = getInitialState();

export function getInitialState() {
  return {
    lastRefreshed: null,
    loading: false,
    loaded: false,
    data: {
      yesNoAndAll: [
        {
          text: "",
          value: ""
        },
        {
          text: "Yes",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ],
      yesNo: [
        {
          text: "Yes",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ],
      trueFalse: [
        {
          text: "True",
          value: 1
        },
        {
          text: "False",
          value: 0
        }
      ],
      booleanTrueFalse: [
        {
          text: "True",
          value: true
        },
        {
          text: "False",
          value: false
        }
      ],

      // dynamic:
      allLevyCollections: [],
      currentLevyCollections: [],
      roleCodeDescriptions: {},
      roleCodes: [],

      // static:
      applicationStatusDescriptions: {},
      applicationStatuses: [],
      assignedPaymentStatusDescriptions: {},
      assignedPaymentStatuses: [],
      contactPositionDescriptions: {},
      contactPositions: [],
      contactStatusDescriptions: {},
      contactStatuses: [],
      contactTypeDescriptions: {},
      contactTypes: [],
      estimatorTemplateTypeDescriptions: {},
      estimatorTemplateTypes: [],
      invoiceStatusDescriptions: {},
      invoiceStatuses: [],
      jobFrequencyUnitDescriptions: {},
      jobFrequencyUnits: [],
      jobTypeDescriptions: {},
      jobTypes: [],
      levyCollectionProviderStatusDescriptions: {},
      levyCollectionProviderStatuses: [],
      levyCollectionProviderWarningTypeDescriptions: {},
      levyCollectionProviderWarningTypes: [],
      levyCollectionStatusDescriptions: {},
      levyCollectionStatuses: [],
      levyCollectionTaskTypeDescriptions: {},
      levyCollectionTaskTypes: [],
      levyCollectionTypeDescriptions: {},
      levyCollectionTypes: [],
      loanTypeDescriptions: {},
      loanTypes: [],
      manualFinalisationReasonDescriptions: {},
      manualFinalisationReasons: [],
      noticeTypeDescriptions: {},
      noticeTypes: [],
      organisationClassificationDescriptions: {},
      organisationClassifications: [],
      organisationOwnershipDescriptions: {},
      organisationOwnerships: [],
      overrideCategories: [],
      overrideCategoryDescriptions: {},
      overrideTypeDescriptions: {},
      overrideTypes: [],
      paymentStatusDescriptions: {},
      paymentStatuses: [],
      permissionCategories: [],
      permissionCategoryDescriptions: {},
      permissionClaimTypeDescriptions: {},
      permissionClaimTypes: [],
      providerContactSectorDescriptions: {},
      providerContactSectors: [],
      providerTaskTypeDescriptions: {},
      providerTaskTypes: [],
      riskFactorTypeDescriptions: {},
      riskFactorTypes: [],
      sapReconciliationWarningTypeDescriptions: {},
      sapReconciliationWarningTypes: [],
      scheduledJobStatusDescriptions: {},
      scheduledJobStatuses: [],
      systemLogActionDescriptions: {},
      systemLogActions: [],
      userStatusDescriptions: {},
      userStatuses: [],
      mfaChallengeOutcomeStatusDescriptions: {},
      mfaAuthenticationMethodDescriptions: {},
      mfaOperationModeDescriptions: {},
      mfaVerificationMethods: [],
      mfaChallengeOutcomeStatuses: [],
      mfaOperationModes: [],
    }
  };
}
